var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("q-table", {
        ref: "table",
        staticClass: "q-mt-md",
        attrs: {
          data: _vm.users_subscribed,
          columns: _vm.columns,
          pagination: _vm.server_pagination,
          selection: "multiple",
          selected: _vm.users_subscribed_selected,
          loading: _vm.loading,
          "row-key": "id",
          "no-data-label": _vm.$t("no_data_avaliable"),
          "no-results-label": _vm.$t("no_results_found"),
          "loading-label": _vm.$t("loading_data"),
          "rows-per-page-label": _vm.$t("items_per_page"),
          "rows-per-page-options": [5, 10, 50, 100],
          "binary-state-sort": ""
        },
        on: {
          "update:pagination": function($event) {
            _vm.server_pagination = $event
          },
          "update:selected": function($event) {
            _vm.users_subscribed_selected = $event
          },
          request: _vm.request
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function(props) {
              return [
                _c("div", { staticClass: "col" }),
                _c("q-btn", {
                  staticClass: "q-mr-sm",
                  attrs: {
                    color: "tertiary",
                    icon: "fas fa-file-download",
                    label: _vm.$t("download_guest_list"),
                    disable:
                      _vm.users_subscribed.length < 1 || !_vm.manageLiveClasses
                  },
                  on: { click: _vm.downloadGuestList }
                }),
                _vm.users_subscribed_selected.length > 0
                  ? _c("q-btn", {
                      staticClass: "q-mr-sm",
                      attrs: {
                        color: "negative",
                        icon: "fas fa-ban",
                        label: _vm.$t("remove")
                      },
                      on: { click: _vm.removeUsers }
                    })
                  : _vm._e()
              ]
            }
          },
          {
            key: "header",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                [
                  _c(
                    "q-th",
                    { attrs: { "auto-width": "" } },
                    [
                      _c("q-checkbox", {
                        attrs: {
                          "indeterminate-value": "some",
                          disable: !_vm.manageLiveClasses
                        },
                        model: {
                          value: props.selected,
                          callback: function($$v) {
                            _vm.$set(props, "selected", $$v)
                          },
                          expression: "props.selected"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._l(props.cols, function(col) {
                    return _c(
                      "q-th",
                      { key: col.name, attrs: { props: props } },
                      [
                        _vm._v(
                          "\n\t\t\t\t" + _vm._s(_vm.$t(col.label)) + "\n\t\t\t"
                        )
                      ]
                    )
                  })
                ],
                2
              )
            }
          },
          {
            key: "body",
            fn: function(props) {
              return _c(
                "q-tr",
                {},
                [
                  _c(
                    "q-td",
                    { attrs: { "auto-width": "" } },
                    [
                      _c("q-checkbox", {
                        attrs: {
                          color: "primary",
                          disable: !_vm.manageLiveClasses
                        },
                        model: {
                          value: props.selected,
                          callback: function($$v) {
                            _vm.$set(props, "selected", $$v)
                          },
                          expression: "props.selected"
                        }
                      })
                    ],
                    1
                  ),
                  _c("q-td", { key: "id", attrs: { props: props } }, [
                    _vm._v("\n\t\t\t\t" + _vm._s(props.row.id) + "\n\t\t\t")
                  ]),
                  _c("q-td", { key: "name", attrs: { props: props } }, [
                    _vm._v("\n\t\t\t\t" + _vm._s(props.row.name) + "\n\t\t\t")
                  ]),
                  _c("q-td", { key: "email", attrs: { props: props } }, [
                    _vm._v("\n\t\t\t\t" + _vm._s(props.row.email) + "\n\t\t\t")
                  ]),
                  _c("q-td", { key: "document", attrs: { props: props } }, [
                    _vm._v(
                      "\n\t\t\t\t" + _vm._s(props.row.document) + "\n\t\t\t"
                    )
                  ]),
                  _c(
                    "q-td",
                    { key: "branches", attrs: { props: props } },
                    [
                      props.row.branches.length > 1
                        ? _c(
                            "q-btn",
                            {
                              attrs: {
                                color: "primary",
                                "text-color": "white",
                                label: _vm.getQuantityBranches(
                                  props.row.branches
                                ),
                                "no-ripple": ""
                              }
                            },
                            [
                              _c("q-tooltip", [
                                props.row.branches.length > 1
                                  ? _c(
                                      "p",
                                      { staticClass: "tooltip q-mb-sm" },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t" +
                                            _vm._s(_vm.$t("branches")) +
                                            ":\n\t\t\t\t\t\t\t"
                                        ),
                                        _vm._l(props.row.branches, function(
                                          branch,
                                          index
                                        ) {
                                          return _c("span", { key: index }, [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t" +
                                                _vm._s(branch) +
                                                "\n\t\t\t\t\t\t\t\t"
                                            ),
                                            props.row.branches.length - 1 >
                                            index
                                              ? _c("span", [_vm._v(", ")])
                                              : _vm._e()
                                          ])
                                        })
                                      ],
                                      2
                                    )
                                  : _vm._e()
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      props.row.branches.length < 2
                        ? _c("span", [
                            _vm._v(_vm._s(String(props.row.branches)))
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "q-td",
                    { key: "areas", attrs: { props: props } },
                    [
                      props.row.areas.length > 1
                        ? _c(
                            "q-btn",
                            {
                              attrs: {
                                color: "primary",
                                "text-color": "white",
                                label: props.row.areas
                                  ? props.row.areas.length
                                  : 0,
                                "no-ripple": ""
                              }
                            },
                            [
                              _c("q-tooltip", [
                                props.row.areas.length > 1
                                  ? _c(
                                      "p",
                                      { staticClass: "tooltip q-mb-sm" },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t" +
                                            _vm._s(_vm.$t("areas")) +
                                            ":\n\t\t\t\t\t\t\t"
                                        ),
                                        _vm._l(props.row.areas, function(
                                          area,
                                          index
                                        ) {
                                          return _c("span", { key: index }, [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t" +
                                                _vm._s(area) +
                                                "\n\t\t\t\t\t\t\t\t"
                                            ),
                                            props.row.areas.length - 1 > index
                                              ? _c("span", [_vm._v(", ")])
                                              : _vm._e()
                                          ])
                                        })
                                      ],
                                      2
                                    )
                                  : _vm._e()
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      props.row.areas.length < 2
                        ? _c("span", [_vm._v(_vm._s(String(props.row.areas)))])
                        : _vm._e()
                    ],
                    1
                  ),
                  _c("q-td", { key: "profile", attrs: { props: props } }, [
                    _vm._v(
                      "\n\t\t\t\t" +
                        _vm._s(_vm.translateProfiles(props.row.profile)) +
                        "\n\t\t\t"
                    )
                  ]),
                  _c(
                    "q-td",
                    { key: "is_present", attrs: { props: props } },
                    [
                      _c("q-checkbox", {
                        attrs: { "aria-readonly": "true", disable: "" },
                        model: {
                          value: props.row.is_present,
                          callback: function($$v) {
                            _vm.$set(props.row, "is_present", $$v)
                          },
                          expression: "props.row.is_present"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "q-td",
                    { key: "subscribe_date", attrs: { props: props } },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(_vm.fDate(props.row.subscribe_date)) +
                          "\n\t\t\t"
                      )
                    ]
                  ),
                  _c(
                    "q-td",
                    {
                      key: "actions",
                      attrs: { "auto-width": "", props: props }
                    },
                    [
                      _c(
                        "q-btn",
                        {
                          attrs: {
                            round: "",
                            flat: "",
                            icon: "fas fa-trash",
                            color: "negative",
                            disable: !_vm.manageLiveClasses
                          },
                          on: {
                            click: function($event) {
                              return _vm.removeUser(props)
                            }
                          }
                        },
                        [
                          _c("q-tooltip", [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(_vm.$t("delete_tooltip")) +
                                "\n\t\t\t\t\t"
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            }
          }
        ])
      }),
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3" },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "tertiary",
                label: _vm.$t("back"),
                icon: "fas fa-chevron-left"
              },
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "admin_live_classes" })
                }
              }
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }